(()=>{
  if(window.wbHeaderCartStarted)return;
  window.wbHeaderCartStarted=true;
  let requestNumber=0;
  async function refreshCount(){
    const header=document.querySelector('[data-cart-json]');
    if(!header)return;
    const ticket=++requestNumber;
    try{
      const response=await fetch(header.dataset.cartJson,{headers:{Accept:'application/json'},cache:'no-store'});
      if(!response.ok)return;
      const cart=await response.json();
      if(ticket!==requestNumber||!Number.isInteger(cart.item_count)||cart.item_count<0)return;
      document.querySelectorAll('[data-wb-cart-count]').forEach(el=>{el.textContent=String(cart.item_count);});
    }catch{ /* Keep Shopify's server-rendered count on connection errors. */ }
  }
  window.addEventListener('pageshow',refreshCount);
  document.addEventListener('shopify:section:load',refreshCount);
  document.addEventListener('cart:updated',refreshCount);
  document.addEventListener('cart:refresh',refreshCount);
  refreshCount();
})();
